import script from "./MoveDocumentsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveDocumentsModal.vue?vue&type=script&setup=true&lang=js"

import "./MoveDocumentsModal.vue?vue&type=style&index=0&id=931afd82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-931afd82"]])

export default __exports__